// @ts-nocheck
import { IconPresentationProps } from "@insite/mobius/Icon";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { linkActionStyles, linkIconStyles } from "@store/Themes/common/mixins/link";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

export const linkGetIconProps = (
    src: IconPresentationProps["src"],
    position: "right" | "left" = "left",
    size?: IconPresentationProps["size"] | string,
): LinkPresentationProps["icon"] => ({
    position,
    iconProps: {
        src,
        color: "inherit",
        css: linkIconStyles(typeof size === "number" ? pxToRem(size) : size),
    },
});

export const linkGetActionLinkProps = (
    src?: IconPresentationProps["src"],
    position: "right" | "left" = "left",
    size?: IconPresentationProps["size"] | string,
): LinkPresentationProps => ({
    icon: linkGetIconProps(src, position, size),
    css: css`
        ${linkActionStyles()}
        align-items: flex-start;
    `,
});
